const prefix = 'top-bar';

export const i18n = {
    newInstance: {
        id: `${prefix}.newInstance`,
        defaultMessage: 'New Instance',
    },
} as const;
